import React, { useState, useEffect } from 'react'
import {
  Input,
  Form,
  FormGroup,
  ControlLabel,
  Grid,
  Row,
  Col,
  InputGroup,
  RadioGroup,
  Radio,
  Whisper,
  Tooltip,
  Message,
} from 'rsuite'
import classNames from 'classnames'
import ErrorMessage from '../../message/errorMessage/ErrorMessage'
import { isValidators, isRequired, getMaxLengthData } from '../../../utils/ValidatorUtils'
import AppContext from '../../../context/AppContext'
import './styles.less'
import { verificationOrganization } from '../../../redux/actions/verification'
import InputForm from '../input/InputForm'
import InformationIncon from '../../help/InformationIncon'

export default function CompanyBasicInfoForm({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  getValues,
  setValue,
  clearErrors,
  offerFundedInfoSchema,
}) {
  const { theme } = React.useContext(AppContext)
  const [isLoadingVerification, setIsLoadingVerification] = useState(false)
  const [schema, setSchema] = useState(_schema)
  const [isDisable, setIsDisable] = useState(true)
  const [companyTypeSelected, setCompanyTypeSelected] = useState()
  const [companyNatureSelected, setCompanyNatureSelected] = useState()
  const [isDisabledInputOther, setIsDisabledInputOther] = useState(true)
  const [inputOther, setInputOther] = useState('')
  const [isVerification, setIsVerification] = useState(true)

  const [offerFundedInfo, setOfferFundedInfo] = useState(offerFundedInfoSchema?.docList || [])
  const [granteeType, setGranteeType] = useState(schema.companyNature ? 2 : 3)
  const [subType, setSubType] = useState()

  useEffect(() => {
    setSchema(_schema)
  }, [_schema])

  useEffect(() => {
    setOfferFundedInfo(offerFundedInfoSchema?.docList || [])
  }, [offerFundedInfoSchema])

  useEffect(() => {
    setGranteeType(schema?.companyNature ? 2 : 3)
  }, [schema?.companyNature])

  useEffect(() => {
    onClickVerificationPersonOrganization()
  }, [])

  useEffect(() => {
    if (schema.companyType)
      if (schema.companyType.optionSelected) {
        setCompanyTypeSelected(schema.companyType.optionSelected)
        setValue(schema.companyType.name, schema.companyType.optionSelected)

        if (!schema.companyNature) {
          setSubType(schema.companyType.optionSelected)
        }
      } else {
        setValue(schema.companyType.name)
      }

    if (schema.companyNature)
      if (schema.companyNature.optionSelected) {
        setCompanyNatureSelected(schema.companyNature.optionSelected)
        setValue(schema.companyNature.name, schema.companyNature.optionSelected)
        setSubType(schema.companyNature.optionSelected)
      } else {
        setValue(schema.companyNature.name)
      }

    if (schema.companyNature)
      if (schema.companyNature.inputOther.value) {
        setInputOther(schema.companyNature.inputOther.value)
        setIsDisabledInputOther(false)
        setValue(
          schema.companyNature.inputOther.name,
          schema.companyNature.inputOther.optionSelected
        )
      } else {
        setIsDisabledInputOther(true)
        setValue(schema.companyNature.inputOther.name)
      }
  }, [schema.companyType, schema.companyNature])

  const onClickVerificationPersonOrganization = async () => {
    setIsDisable(false)
    const idNumber = getValues(schema.idNumber.name)
    if (!idNumber) {
      setIsDisable(true)
      return
    }
    setIsLoadingVerification(true)
    let organization
    try {
      organization = await verificationOrganization(idNumber)
      // console.log('organization', organization)
    } catch (e) {}
    setIsLoadingVerification(false)
    if (organization) {
      setValueVerification(organization)
      //setIsDisable(true)
    } else {
      setValueVerification()
    }
    setValue('verifycation', idNumber)
    setIsVerification(true)
    setIsDisable(false)
  }

  const setValueVerification = (value) => {
    // if (value) {
    setValue('id', value?.organizationId || '')
    // setValue(schema.idNumber.name, value?.taxId || '')
    setValue(schema.companyName.name, value?.organizationName || '')
    setValue(schema.mobile.name, value?.mobileNumber || '')
    setValue(schema.telephone.name, value?.telephoneNumber || '')
    setValue(schema.fax.name, value?.fax || '')
    setValue(schema.email.name, value?.email || '')
    schema.companyType?.name && setValue(schema.companyType?.name, value?.organizationalType || '')
    schema.companyNature?.name &&
      setValue(schema.companyNature?.name, value?.masterOrganizationalBusinessTypeId || '')
    schema.companyNature?.inputOther?.name &&
      setValue(schema.companyNature?.inputOther?.name, value?.otherOrganizationalBusinessType || '')
    clearErrors()

    if (
      value?.masterOrganizationalBusinessTypeId == '13' ||
      value?.masterOrganizationalBusinessTypeId == '32'
    ) {
      setIsDisabledInputOther(false)
    } else {
      setIsDisabledInputOther(true)
    }

    if (schema.companyNature) {
      setSubType(value?.masterOrganizationalBusinessTypeId)
    } else {
      setSubType(value?.organizationalType)
    }

    // }
  }

  const renderOfferFundedInfo = (granteeType, subType) => {
    var data = []
    offerFundedInfo?.forEach((element) => {
      if (element.type == granteeType) {
        element?.subTypeList?.forEach((item) => {
          if (item.subType == subType) {
            data = item.list
          }
        })
      }
    })

    console.log(
      'offerFundedInfo',
      offerFundedInfo,
      'granteeType',
      granteeType,
      'subType',
      subType,
      'data',
      data
    )
    return data || []
  }

  const renderCompanyTypeLabel = (label) => {
    if (!label || typeof label !== 'string') {
      return label
    }

    const highlightWords = ['ไม่ใช่', 'เป็น']
    const parts = label.split(new RegExp(`(${highlightWords.join('|')})`, 'g'))

    return parts.map((part, index) =>
      highlightWords.includes(part) ? (
        <span key={`${part}-${index}`} style={{ color: '#d0021b' }}>
          {part}
        </span>
      ) : (
        <React.Fragment key={`${part}-${index}`}>{part}</React.Fragment>
      )
    )
  }

  return (
    <>
      <Grid fluid>
        <Form fluid className="company-basic-info-form">
          <FormGroup>
            <Row>
              <Col xs={24} sm={24} md={9} lg={9}>
                <ControlLabel
                  className={classNames(
                    'style-text-lable',
                    isRequired(schema.idNumber.validators) && 'required'
                  )}
                >
                  {schema.idNumber.label}
                </ControlLabel>
                <ErrorMessage error={errors.idNumber} />
                <ErrorMessage error={errors.verifycation} />
                <InputGroup style={{ width: '100%' }}>
                  <Controller
                    name={schema.idNumber.name}
                    control={control}
                    defaultValue={schema.idNumber.value}
                    rules={isValidators(schema.idNumber.validators)}
                    render={(props) => {
                      return (
                        <Input
                          placeholder={schema.idNumber.label}
                          value={props.value}
                          maxLength={getMaxLengthData(schema.idNumber.validators).value}
                          onChange={(value, e) => {
                            if (value) {
                              value = value?.replace(' ', '')
                            }
                            if (isNaN(value)) {
                              return
                            }

                            if (
                              value.length == getMaxLengthData(schema.idNumber.validators).value
                            ) {
                              setValue('verifycation')
                              setIsVerification(false)
                              setIsDisable(true)
                            } else {
                              setIsVerification(true)
                            }

                            props.onChange(value)
                          }}
                        />
                      )
                    }}
                  />

                  <Controller
                    key="verifycation"
                    name="verifycation"
                    control={control}
                    defaultValue={schema.idNumber.value}
                    rules={{ required: `กรุณาตรวจสอบ${schema.idNumber.label}ก่อน` }}
                  />
                  <Whisper
                    placement="bottom"
                    open={!isVerification}
                    speaker={<Tooltip style={{ fontSize: 15 }}>กรุณาตรวจสอบ</Tooltip>}
                  >
                    <InputGroup.Button
                      onClick={() => onClickVerificationPersonOrganization()}
                      disabled={isLoadingVerification}
                    >
                      ตรวจสอบ
                    </InputGroup.Button>
                  </Whisper>
                </InputGroup>
              </Col>
              <Col xs={24} sm={24} md={13} lg={13}>
                <ControlLabel
                  className={classNames(
                    'style-text-lable',
                    isRequired(schema.companyName.validators) && 'required'
                  )}
                >
                  {schema.companyName.label}
                </ControlLabel>
                <ErrorMessage error={errors.companyName} />
                <Controller
                  name={schema.companyName.name}
                  control={control}
                  defaultValue={schema.companyName.value}
                  rules={isValidators(schema.companyName.validators)}
                  render={(props) => {
                    return (
                      <Input
                        placeholder={schema.companyName.label}
                        value={props.value}
                        disabled={isDisable}
                        onChange={(value, e) => {
                          props.onChange(value)
                        }}
                        // inputRef={register(isValidators(schema.companyName.validators))}
                      />
                    )
                  }}
                />
              </Col>
            </Row>
          </FormGroup>

          {schema.subCompanyName && (
            <FormGroup>
              <Row>
                <Col xs={24} sm={24} md={22} lg={22}>
                  <ControlLabel
                    className={classNames(
                      'style-text-lable',
                      isRequired(schema.subCompanyName.validators) && 'required'
                    )}
                  >
                    {schema.subCompanyName.label}
                  </ControlLabel>
                  <ErrorMessage error={errors.subCompanyName} />
                  {/* <InputForm
                    schema={schema.subCompanyName}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                  /> */}
                  <Controller
                    name={schema.subCompanyName.name}
                    control={control}
                    defaultValue={schema.subCompanyName.value}
                    rules={isValidators(schema.subCompanyName.validators)}
                    render={(props) => {
                      return (
                        <Input
                          placeholder={schema.subCompanyName.label}
                          value={props.value}
                          disabled={isDisable}
                          onChange={(value, e) => {
                            props.onChange(value)
                          }}
                        />
                      )
                    }}
                  />
                </Col>
              </Row>
            </FormGroup>
          )}

          {schema.companyType && (
            <FormGroup>
              <Row>
                <Col xs={24} sm={24} md={24} lg={24}>
                  <ControlLabel
                    className={classNames(
                      'style-text-lable',
                      isRequired(schema.companyType.validators) && 'required'
                    )}
                  >
                    {schema.companyType.label}
                  </ControlLabel>
                  <ErrorMessage error={errors.companyType} />
                  <Controller
                    name={schema.companyType.name}
                    defaultValue={schema.companyType.optionSelected}
                    control={control}
                    rules={isValidators(schema.companyType.validators)}
                    render={(props) => {
                      return (
                        <RadioGroup
                          inline
                          value={props.value}
                          // disabled={isDisable}
                          onChange={(value) => {
                            props.onChange(value)
                            setCompanyTypeSelected(value)

                            if (!schema.companyNature) {
                              setSubType(value)
                            }
                          }}
                        >
                          {schema.companyType.options.map((item) => {
                            return (
                              <>
                                <Radio value={item.value} disabled={item.disabled || isDisable}>
                                  {renderCompanyTypeLabel(item.label)}
                                </Radio>
                                {item.value == 14 && (
                                  <InformationIncon
                                    iconColor={'#f17e26'}
                                    backgroundColor={'#fff'}
                                    color={'#000'}
                                    message={
                                      'มีใบสำคัญแสดงการรับรองเป็นองค์กรสาธารณประโยชน์ ที่ออกโดย กรมพัฒนาสังคมและสวัสดิการ กระทรวงการพัฒนาสังคมและความมั่นคงของมนุษย์ (พม.)'
                                    }
                                  />
                                )}
                              </>
                            )
                          })}
                        </RadioGroup>
                      )
                    }}
                  />
                </Col>
              </Row>
            </FormGroup>
          )}

          {schema.companyNature && (
            <FormGroup>
              <Row>
                <Col xs={24} sm={24} md={24} lg={24}>
                  <ControlLabel
                    className={classNames(
                      'style-text-lable',
                      isRequired(schema.companyNature.validators) && 'required'
                    )}
                  >
                    {schema.companyNature.label}
                  </ControlLabel>
                  <ErrorMessage error={errors.companyNature} />
                  <Controller
                    name={schema.companyNature.name}
                    defaultValue={schema.companyNature.optionSelected}
                    control={control}
                    rules={isValidators(schema.companyNature.validators)}
                    render={(props) => {
                      return (
                        <RadioGroup
                          inline
                          value={props.value}
                          disabled={isDisable}
                          onChange={(value) => {
                            props.onChange(value)
                            setCompanyNatureSelected(value)
                            setIsDisabledInputOther(true)
                            clearErrors(schema.companyNature.inputOther.name)

                            if (value == 13 || value == 32) {
                              setIsDisabledInputOther(false)
                            }

                            setSubType(value)
                          }}
                        >
                          {schema.companyNature.options.map((item, index, array) => {
                            return (
                              index % 2 == 0 && (
                                <Row>
                                  <Col xs={24} sm={24} md={12} lg={10}>
                                    <Radio
                                      value={array[index].value}
                                      disabled={array[index].disabled || isDisable}
                                    >
                                      {index + 1}. {array[index].label}
                                    </Radio>
                                  </Col>
                                  {index + 1 < array.length && (
                                    <Col xs={24} sm={24} md={12} lg={14}>
                                      <Radio
                                        value={array[index + 1].value}
                                        disabled={array[index + 1].disabled || isDisable}
                                      >
                                        {index + 2}. {array[index + 1].label}
                                      </Radio>
                                    </Col>
                                  )}
                                </Row>
                              )
                            )
                          })}

                          {/* <>
                          <Controller
                            name={'OTHER'}
                            control={control}
                            defaultValue={schema.companyNature.inputOther.isSelected}
                            render={(props) => {
                              return (
                                <Radio
                                  value={'OTHER'}
                                  checked={!isDisabledInputOther}
                                  onChange={(value, checked, e) => {
                                    props.onChange(checked)
                                    setIsDisabledInputOther(false)
                                  }}
                                >
                                  {schema.companyNature.options.length + 1}.{' '}
                                  {schema.companyNature.inputOther.label}
                                </Radio>
                              )
                            }}
                          />
                        </> */}
                          <ErrorMessage error={errors.inputOther} />
                          <Controller
                            name={schema.companyNature.inputOther.name}
                            control={control}
                            defaultValue={inputOther}
                            rules={
                              !isDisabledInputOther &&
                              isValidators(schema.companyNature.inputOther.validators)
                            }
                            render={(props) => {
                              return (
                                <Input
                                  style={{ width: 'calc(100% - 35px)', marginLeft: 35 }}
                                  placeholder="โปรดระบุ"
                                  value={props.value}
                                  disabled={isDisabledInputOther || isDisable}
                                  onChange={(value, e) => {
                                    props.onChange(value)
                                  }}
                                />
                              )
                            }}
                          />
                        </RadioGroup>
                      )
                    }}
                  />
                </Col>
              </Row>
            </FormGroup>
          )}

          <Row>
            {granteeType && subType && offerFundedInfo && offerFundedInfoSchema && (
              <Message
                type="info"
                showIcon
                style={{ marginTop: 5 }}
                description={
                  <>
                    <strong>{offerFundedInfoSchema?.header}</strong>
                    <ul style={{ marginTop: 10 }}>
                      {renderOfferFundedInfo(granteeType, subType)?.map((item, index) => {
                        return <li key={index}>{item}</li>
                      })}
                    </ul>
                  </>
                }
              />
            )}
          </Row>

          <br />

          <FormGroup>
            <Row>
              <Col xs={24} sm={24} md={9} lg={9}>
                <ControlLabel
                  className={classNames(
                    'style-text-lable',
                    isRequired(schema.telephone.validators) && 'required'
                  )}
                >
                  {schema.telephone.label}
                </ControlLabel>
                <ErrorMessage error={errors.telephone} />
                <Controller
                  name={schema.telephone.name}
                  control={control}
                  defaultValue={schema.telephone.value}
                  rules={isValidators(schema.telephone.validators)}
                  render={(props) => {
                    return (
                      <Input
                        placeholder={schema.telephone.label}
                        value={props.value}
                        maxLength={getMaxLengthData(schema.telephone.validators).value}
                        disabled={isDisable}
                        onChange={(value, e) => {
                          if (isNaN(value)) {
                            return
                          }
                          props.onChange(value)
                        }}
                      />
                    )
                  }}
                />
              </Col>
              <Col xs={24} sm={24} md={13} lg={13}>
                <ControlLabel
                  className={classNames(
                    'style-text-lable',
                    isRequired(schema.mobile.validators) && 'required'
                  )}
                >
                  {schema.mobile.label}
                </ControlLabel>
                <ErrorMessage error={errors.mobile} />
                <Controller
                  name={schema.mobile.name}
                  control={control}
                  defaultValue={schema.mobile.value}
                  rules={isValidators(schema.mobile.validators)}
                  render={(props) => {
                    return (
                      <Input
                        placeholder={schema.mobile.label}
                        value={props.value}
                        maxLength={getMaxLengthData(schema.mobile.validators).value}
                        disabled={isDisable}
                        onChange={(value, e) => {
                          if (isNaN(value)) {
                            return
                          }
                          props.onChange(value)
                        }}
                      />
                    )
                  }}
                />
              </Col>
            </Row>
          </FormGroup>
          <FormGroup>
            <Row>
              <Col xs={24} sm={24} md={9} lg={9}>
                <ControlLabel
                  className={classNames(
                    'style-text-lable',
                    isRequired(schema.fax.validators) && 'required'
                  )}
                >
                  {schema.fax.label}
                </ControlLabel>
                <ErrorMessage error={errors.fax} />
                <Controller
                  name={schema.fax.name}
                  control={control}
                  defaultValue={schema.fax.value}
                  rules={isValidators(schema.fax.validators)}
                  render={(props) => {
                    return (
                      <Input
                        placeholder={schema.fax.label}
                        value={props.value}
                        maxLength={getMaxLengthData(schema.fax.validators).value}
                        disabled={isDisable}
                        onChange={(value, e) => {
                          if (isNaN(value)) {
                            return
                          }
                          props.onChange(value)
                        }}
                      />
                    )
                  }}
                />
              </Col>
              <Col xs={24} sm={24} md={13} lg={13}>
                <ControlLabel
                  className={classNames(
                    'style-text-lable',
                    isRequired(schema.email.validators) && 'required'
                  )}
                >
                  {schema.email.label}
                </ControlLabel>
                <ErrorMessage error={errors.email} />
                <Controller
                  name={schema.email.name}
                  control={control}
                  defaultValue={schema.email.value}
                  rules={isValidators(schema.email.validators)}
                  render={(props) => {
                    return (
                      <Input
                        placeholder={schema.email.label}
                        value={props.value}
                        disabled={isDisable}
                        onChange={(value, e) => {
                          props.onChange(value)
                        }}
                        // inputRef={register(isValidators(schema.email.validators))}
                      />
                    )
                  }}
                />
              </Col>
            </Row>
          </FormGroup>
        </Form>
      </Grid>
    </>
  )
}
